/**
 * Helper to define an enum in a consistent, immutable way.
 * Returns { ENUM, VALUES } where both are frozen.
 * @param {Object} obj - The enum object
 * @returns {{ENUM: Object, VALUES: Array}}
 */

export function makeEnum(obj) {
  const ENUM = Object.freeze(obj);
  const VALUES = Object.freeze(Object.values(ENUM));
  return { ENUM, VALUES };
}
